export default __webpack_public_path__ + "static/media/Frame 505.52048aa2.svg";